import { Image, Link, StyleSheet, Text, View } from "@react-pdf/renderer";
import { extractUploadFileName, GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2 } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingCount, getGoalTrackingPercentage } from "helpers/assessment";
import attachments_img from "Assets/images/AttachmentIcon.png"
import Html from "react-pdf-html";
import graphSliderImg from "../../../../../Assets/images/graphSliderImg.png"
import moment from "moment";
import PDFHtmlRenderer from "./PDFHtmlRenderer";

const TreatmentSummarySection = ({ data, therapistDetails, showChart = false, chartImages = [], styles }) => {
    console.log('data from summary', data)
    const styleInner = {
        paraInner: {
            fontSize: 9,
            fontWeight: 'normal',
            lineHeight: "13px"
        },
    }
    return (
        <>
            {data?.length > 0 ? (
                data?.map((item, index) => {
                    // const attachments = goal?.goal_attachementData ? JSON.parse(goal?.goal_attachementData) : [];
                    return (
                        <View style={{ marginBottom: 10 }}>
                            <View wrap={false}>
                                <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>{index + 1}. AREA: <Text style={{ fontWeight: 400 }}>{item?.area || ""}</Text> </Text>

                                <View style={{ marginTop: "10px", ...styles.flex, gap: "12px", paddingLeft: 10 }} wrap={false}>
                                    <View style={{ width: "50%" }}>
                                        <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>GOAL </Text>

                                        <Text style={{ ...styles.para, marginTop: 4 }}>
                                            {item?.goal || ""}
                                        </Text>
                                    </View>
                                    <View style={{ width: "50%" }}>
                                        <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>STATUS</Text>
                                        <Text style={{ ...styles.para, marginTop: 4 }}>
                                            {item?.status?.label || ""}
                                        </Text>
                                    </View>
                                </View>

                                <View style={{ marginTop: "10px", ...styles.flex, gap: "12px", paddingLeft: 10 }} wrap={false}>
                                    <View style={{ width: "50%" }}>
                                        <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>DESCRIPTION </Text>

                                        <Text style={{ ...styles.para, marginTop: 4 }}>
                                            {item?.goal_description || ""}
                                        </Text>
                                    </View>
                                    {
                                        item?.show_tracker != "hidden" &&
                                        <View style={{ width: "50%" }}>
                                            <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>SESSION OUTCOMES</Text>
                                            <View style={{ marginTop: "10px", ...styles.flex, justifyContent: "space-between", }}>


                                                <View style={{ marginTop: "10px" }}>
                                                    {chartImages?.[index] && (
                                                        <Image style={{ width: 100 }} src={chartImages?.[index]} />
                                                    )}
                                                </View>
                                                {item?.scores?.length > 0 ? (
                                                    <View style={{ width: "60%", gap: "4px" }}>

                                                        {Object.entries(GOAL_TRACK_PARAMETERS_V2)?.map(([param, label], goalIndex) => {
                                                            const color = GOAL_TRACK_PARAMETERS_COLORS_V2[param];
                                                            // Get the count for this specific parameter (O, P, I)
                                                            const paramIndex = Object.keys(GOAL_TRACK_PARAMETERS_V2).indexOf(param);
                                                            const count = item?.scores?.[paramIndex] || 0;

                                                            // Calculate total sum of all trials
                                                            const totalTrials = item?.scores?.reduce((sum, num) => sum + (num || 0), 0) || 0;

                                                            // Calculate percentage
                                                            const percentage = totalTrials > 0 ? Math.round((count / totalTrials) * 100) : 0;

                                                            return (
                                                                <View style={{ ...styles.flex, justifyContent: "space-between" }}>
                                                                    <View style={{ ...styles.flex, gap: "4px", alignItems: "center" }}>
                                                                        <Text style={{ width: "9px", height: "9px", backgroundColor: color }}></Text>
                                                                        <Text style={{ ...styleInner.paraInner }}>{param}</Text>
                                                                        <Text style={{ ...styleInner.paraInner }}>{label} ({count}/{totalTrials})</Text>
                                                                    </View>
                                                                    <Text style={{ ...styleInner.paraInner }}> {percentage}%</Text>
                                                                </View>
                                                            );
                                                        })}
                                                    </View>
                                                ) : (
                                                    <Text style={{ ...styles.para }}>
                                                        Goal not tracked yet
                                                    </Text>
                                                )}
                                            </View>
                                        </View>
                                    }
                                </View>


                            </View>

                            <View style={{ paddingLeft: 10 }}>
                                <View style={{ marginTop: 7 }} >
                                    <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>GOAL PROGRESSION</Text>
                                    <Text style={{ ...styles.para, marginTop: 4 }}>
                                        <PDFHtmlRenderer
                                            style={{ fontSize: 8, ...styles.para }}
                                            data={item?.goal_notes}
                                        />
                                    </Text>
                                </View>
                                <View style={{ marginTop: 4 }}>
                                    {item?.strategy?.length > 0 && (
                                        <View >
                                            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: "5px" }}>
                                                <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>STRATEGIES</Text>
                                            </View>
                                            {item?.strategy?.map((strategy, strategyIndex) => (
                                                <View style={{ ...styles.flex, marginTop: 4, gap: 20, borderBottom: "0.75px solid #333", paddingBottom: "2px", }}>
                                                    <View style={{ width: "70%", paddingRight: 7 }}>
                                                        <PDFHtmlRenderer
                                                            style={{ fontSize: 8, ...styles.para }}
                                                            data={strategy?.answers}
                                                        />
                                                    </View>
                                                    <View style={{ width: "30%" }}>
                                                        {strategy?.attachmentData?.length && (
                                                            <View style={{ width: "100%" }}>
                                                                <View>
                                                                    <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                                                </View>
                                                                {strategy?.attachmentData?.map((item, index) => (
                                                                    <View style={{ marginTop: '3px', ...styles.flex, gap: "2px", alignItems: "flex-start" }}>
                                                                        <Text style={{ ...styles.link, borderBottom: 0 }} >
                                                                            {index + 1}.
                                                                        </Text>
                                                                        <Link
                                                                            src={item?.attachment_name}
                                                                            style={styles.link}
                                                                        >
                                                                            {extractUploadFileName(item?.attachment_name)}
                                                                        </Link>
                                                                        <Image style={{ width: 6 }} src={attachments_img} alt="attachment_img" />
                                                                    </View>
                                                                ))}
                                                            </View>
                                                        )}
                                                    </View>
                                                </View>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            </View>
                        </View>
                    )
                })
            ) : (
                <Text style={styles.para}>No treatment plans available</Text>
            )}
        </>
    )
}


export default TreatmentSummarySection;